import React from "react";
import TourStep from "@/shared/ui/TourStep";

const steps = [
  {
    selector: ".teamMembers",
    content: (
      <TourStep
        title="Welcome to the Team Profile."
        text="Here, you can see your team members and invite more people to join."
      />
    ),
  },
  {
    selector: "#add-member-card",
    content: (
      <TourStep
        title="Add a member to the team."
        text="Click on the add member button to invite a new member to the team."
      />
    ),
  },
  {
    selector: ".teamMemberSingle",
    content: (
      <TourStep text="Click on a person to see their profile compared to the rest of the team." />
    ),
    stepInteraction: true,
  },
  {
    selector: "#navigation-tabs",
    title: "Dive into your team’s DNA",
    content: (
      <TourStep text="Switch between Personality, Values, and Competencies to view the insights." />
    ),
  },
  {
    selector: "#personality-map-section",
    content: (
      <TourStep text="Personality insights help you understand your team members' behavioural preferences and working styles." />
    ),
  },
  {
    selector: ".personality-map-dimension-single",
    content: (
      <TourStep text="Analyze the teams personality traits in depth and see how they compare to each other." />
    ),
  },
  {
    selector: ".personality-map-dimension-single-see-more",
    content: (
      <TourStep text="Click here  to see more in-depth data and insights." />
    ),
  },
  {
    selector: "#wisgpt-container",
    position: "center",
    title: "WisGPT",
    content: (
      <TourStep text="Use WisGPT to analyse data—ask your own questions or use prompts." />
    ),
  },

  // {
  //   selector: ".valuesGraphSector",
  //   content: (
  //     <TourStep text="Use the values section to discover what motivates your team and shape a culture where everyone can perform at their best." />
  //   ),
  //   stepInteraction: true,
  // },
  // {
  //   selector: ".topMotivatorsTitle",
  //   content: (
  //     <TourStep text="Top motivators help you discover what your team cares about the most." />
  //   ),
  // },
  // {
  //   selector: ".mightStruggleDim",
  //   content: (
  //     <TourStep text="Values on which team members disagree indicate topics you should discuss and make the expected norms explicit to avoid conflicts and misunderstanding." />
  //   ),
  // },
];

export default steps;
